import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]
  static values = { index: Number }

  connect() {
    this.indexValue = this.containerTarget.querySelectorAll(".nested-exercise").length
    this.form = this.element.closest("form")
    if (this.form) {
      this.boundCleanup = this.cleanupBeforeSubmit.bind(this)
      this.form.addEventListener("submit", this.boundCleanup)
    }
  }

  disconnect() {
    if (this.form && this.boundCleanup) {
      this.form.removeEventListener("submit", this.boundCleanup)
    }
  }

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, this.indexValue)
    // afterbegin: the add button sits above the list, so the new exercise
    // appears right under it instead of off-screen at the bottom.
    this.containerTarget.insertAdjacentHTML("afterbegin", content)
    this.indexValue++
    this.updatePositions()
  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest(".nested-exercise")
    const destroyInput = wrapper.querySelector("input[name*='_destroy']")

    if (destroyInput) {
      destroyInput.value = "1"
      wrapper.style.display = "none"
      // Remove required attributes to prevent form validation errors on hidden fields
      wrapper.querySelectorAll("[required]").forEach(field => {
        field.removeAttribute("required")
      })
    } else {
      wrapper.remove()
    }
    this.updatePositions()
  }

  cleanupBeforeSubmit(event) {
    const exercises = this.containerTarget.querySelectorAll(".nested-exercise:not([style*='display: none'])")

    exercises.forEach((exercise) => {
      const exerciseId = exercise.querySelector("input[name*='[exercise_id]']")
      const repsField = exercise.querySelector("input[name*='[reps]']")
      const isEmpty = !exerciseId?.value && !repsField?.value

      if (isEmpty) {
        // Completely empty card: remove silently
        const destroyInput = exercise.querySelector("input[name*='_destroy']")
        if (destroyInput) {
          destroyInput.value = "1"
          exercise.style.display = "none"
        } else {
          exercise.remove()
        }
      }
    })

    this.updatePositions()
  }

  updatePositions() {
    const visibleExercises = this.containerTarget.querySelectorAll(".nested-exercise:not([style*='display: none'])")
    visibleExercises.forEach((exercise, index) => {
      const positionInput = exercise.querySelector("input[name*='[position]']")
      if (positionInput) {
        positionInput.value = index + 1
      }
    })
  }
}
